<template>
	<header-block title="" border="0"></header-block>
	<CustomerLoadWait :customer="customerMove && !loading" />
	<div class="header" v-if="customerMove">
		<img :src="customerMove.move.backgroundImage" />
	</div>
	<transition>
		<div v-if="customerMove" class="content">

			<h1>{{customerMove.title}}</h1>

			<p>
				{{customerMove.description}}
			</p>

			<p>
				<v-chip class="mt-3" v-if="customerMove.isPending" variant="outlined" size="small">Not started</v-chip>
			</p>

			<div class="anchor-bottom" >
				<v-row class="mt-3">
					<v-col class="v-col-1 timeCol">
						<img :src="require('@/assets/clock.png')">
					</v-col>
					<v-col>
						{{ customerMove.move.timeToComplete }} minutes
					</v-col>
				</v-row>
				<MGButton v-if="customerMove.move.cmsPage" :text="customerMove.move.actionButtonText" fullWidth @click="cmsAction(customerMove.move)" />
				<MGButton v-if="customerMove.move.appScreen" :text="customerMove.move.actionButtonText" fullWidth @click="appAction(customerMove.move)" />
				<MGButton v-if="customerMove.move.websiteUrl" :text="customerMove.move.actionButtonText" fullWidth @click="action(customerMove.move)" />
				<div v-for="a in customerMove.move.actions" :key="a.id">
					<MGButton v-if="a.cmsPage" :text="a.cta" fullWidth @click="cmsAction" />
					<MGButton v-if="a.appScreen" :text="a.cta" fullWidth @click="multiActionAppAction(a.appScreen)" />
					<MGButton v-if="a.websiteUrl" :text="a.cta" fullWidth @click="action" />
				</div>
			</div>

		</div>
	</transition>
</template>

<script>
import Services from '../mixins/Services';
import CustomerLoadWait from './elements/CustomerLoadWait.vue';
import HeaderBlock from './elements/HeaderBlock.vue';
import MGButton from './elements/MGButton.vue';

export default {
	mixins: [Services],
	components: {CustomerLoadWait, HeaderBlock, MGButton},
	data() {
		return {
			loading: false
		}
	},
	methods: {
		onLoad: async function() {
			this._getCustomer();
			this._getCustomerMove(this.$route.params.id, () => {
				this._markCustomerMoveAsSeen(this.$route.params.id);
				if (this.customerMove.move.cmsPage) {
					this._getCmsArticleByKey(this.customerMove.move.cmsPage, (article) => {
						this.customerMove.move.cmsPage = article.id;
					});
				}
			});
		},
		action: function(move){
			this.loading = true;
			this._markCustomerMoveAsActioned(this.$route.params.id, () => {
				if (move.actionUrl && move.actionUrl != ''){ window.location.href = move.actionUrl; }
				if (move.websiteUrl && move.websiteUrl != '' ){ window.location.href = move.websiteUrl; }
			});
		},
		cmsAction: function(move){
			this.loading = true;
			this._markCustomerMoveAsActioned(this.$route.params.id, () => {
				this.$router.replace('/Articles/' + move.cmsPage);
			});
		},
		appAction: function(move){
			this.loading = true;
			this._markCustomerMoveAsActioned(this.$route.params.id, () => {
				this.processAction(move.appScreen.toLowerCase());
			});
		},
		multiActionAppAction: function(screen){
			this.loading = true;
			this._markCustomerMoveAsActioned(this.$route.params.id, () => {
				this.processAction(screen);
			});
		},
		processAction: function(screen) {
			screen = screen.toLowerCase();
			if(screen.includes('/questionnaire')) {
				this.$router.replace('/Questionnaire/' + screen.split('/')[2]); return;
			}
			if(screen.includes('/plan')) {
				this.$router.replace('/SpendingPlan'); return;
			}
			if(screen.includes('/marketplace')) {
				this.$router.replace('/MarketPlace'); return;
			}
			if(screen.includes('/benefits')) {
				this.$router.replace('/Benefits'); return;
			}
			else if(screen.includes('/spending')) {
				this.$router.replace('/SpendingAnalysis'); return;
			}
			else if(screen.includes('/goals')) {
				this.$router.replace('/Goals'); return;
			}
			else if(screen.includes('/finances')) {
				this.$router.replace('/money'); return;
			}
			else if(screen.includes('/you')) {
				this.$router.replace('/you'); return;
			}
			else if(screen.includes('/guide')) {
				this.$router.replace('/guides'); return;
			}
			else if(screen.includes('/recommendedvouchers')) {
				this.$router.replace('/recommendedvouchers'); return;
			}
			else if(screen.includes('/shopvouchers')) {
				this.$router.replace('/shopvouchers'); return;
			}
			else {
				this.$router.replace('/');
			}
		}
	},
	mounted: function () {
		this.onLoad();
	},
}
</script>

<style scoped>

h1 {
	font-size: 24px;
	margin-bottom: 20px;
}

h2 {
	font-size: 16px;
	margin-bottom: 10px;
}

p {
	font-size: 15px;
}

.header {
	background-color: var(--background-color-alt);
	height: 160px;
	margin-left: -30px;
	margin-right: -30px;
	margin-top: -20px;
	z-index: 200 !important;
	text-align: center;
	position: relative;
	img {
		height: 120px;
		width: 120px;
		border-radius: 50%;
		object-fit: cover;
	}
}

.content {
	padding-top: 30px;
}

.actioned {
	padding: 20px;
	border-radius: 16px;
	background: linear-gradient(64.16deg, rgba(119, 164, 167, 0.2) 18.08%, rgba(170, 206, 205, 0.2) 85.4%);
	.completedCheck {
		float: right;
		margin-top: -16px;
		margin-right: -7px;
	}
}



</style>

  
